import { startSubMerchantSession } from "@/lib/authStorage";

/**
 * EPS-5027: Alt bayi token'ının ana bayi sekmesinden yeni sekmeye taşınması.
 *
 * Token URL'e konmuyor (tarayıcı geçmişine ve log'lara düşerdi); bunun yerine `localStorage`'a
 * tek kullanımlık bir anahtarla yazılıyor, URL yalnızca bu anahtarın kimliğini taşıyor. Yeni
 * sekme token'ı okuyup anahtarı hemen siliyor ve token'ı sekmeye özel `sessionStorage`'a alıyor
 * — böylece ana bayinin kendi oturumu bozulmuyor (bkz. authStorage.js).
 *
 * Sekme, token isteği beklenmeden tıklama anında açılıyor: `await` sonrasında açılan pencereyi
 * tarayıcılar popup olarak engelliyor. Bu yüzden yeni sekme token'ın yazılmasını bekliyor.
 */
const HANDOFF_PREFIX = "subMerchantHandoff:";
const HANDOFF_FAILED = "failed";
const HANDOFF_TTL = 60000;
const HANDOFF_POLL_INTERVAL = 150;

export const SUB_MERCHANT_SESSION_PATH = "/sub-merchant/session";

export const openSubMerchantPanel = (loadToken) => {
  const handoffId = crypto.randomUUID();
  const key = HANDOFF_PREFIX + handoffId;

  window.open(
    `${SUB_MERCHANT_SESSION_PATH}?h=${handoffId}`,
    "_blank",
    "noopener",
  );

  return loadToken()
    .then((jwtToken) => {
      localStorage.setItem(key, jwtToken.split(" ").pop());
      // Yeni sekme açılmadıysa (popup engeli) token localStorage'da kalmasın.
      setTimeout(() => localStorage.removeItem(key), HANDOFF_TTL);
    })
    .catch((err) => {
      localStorage.setItem(key, HANDOFF_FAILED);
      setTimeout(() => localStorage.removeItem(key), HANDOFF_TTL);
      throw err;
    });
};

/**
 * Yeni sekmede çalışır: token yazılana kadar bekler, yazılınca oturumu başlatır.
 * `onResult(başarılı)` ile sonuç bildirilir, dönen fonksiyon beklemeyi iptal eder.
 */
export const consumeSubMerchantHandoff = (handoffId, onResult) => {
  if (!handoffId) {
    onResult(false);
    return () => {};
  }

  const key = HANDOFF_PREFIX + handoffId;
  const deadline = Date.now() + HANDOFF_TTL;

  const intervalId = setInterval(() => {
    const token = localStorage.getItem(key);

    if (!token && Date.now() < deadline) return;

    clearInterval(intervalId);
    localStorage.removeItem(key);

    if (!token || token === HANDOFF_FAILED) {
      onResult(false);
      return;
    }

    startSubMerchantSession(token);
    onResult(true);
  }, HANDOFF_POLL_INTERVAL);

  return () => clearInterval(intervalId);
};
